import { render, staticRenderFns } from "./dyrsTag.vue?vue&type=template&id=5fb9fdd5"
import script from "./dyrsTag.vue?vue&type=script&lang=js"
export * from "./dyrsTag.vue?vue&type=script&lang=js"
import style0 from "./dyrsTag.vue?vue&type=style&index=0&id=5fb9fdd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports